import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Seo from "../components/Seo";

const PcdPharmaFranchiseCompany = () => {
  const handleSearchToggle = () => {
    // Implement your search toggle logic here
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Seo
        title="Top PCD Pharma Franchise Company in India | Bioversal Remedies"
        description="Join Bioversal Remedies, India’s trusted PCD Pharma Franchise Company. Get monopoly rights, top-quality medicines & best franchise support for pharma success."
        type="webapp"
        name="Bioversal Remedies"
      />
      <div className="animate__animated animate__fadeIn">
        <div className="container-fluid mt-5 p-0">
          <div className="bg_cont__45__ppfcompany ban__nerrr">
            <h2 style={{ color: "#fff", zIndex: "99" }}>
              PCD Pharma Franchise Companies
            </h2>
          </div>
        </div>
        <div className="container mt-5">
          <div className="col-12 col-lg-12 mb-5">
             {/* Heading */}
    <h1 className="heading-1" id="PCD_Pharma_Franchise_Company-2">
      PCD Pharma Franchise Company
    </h1>

    {/* Paragraphs */}
    <p className="serv_all__para">
      Bioversal Remedies is the fastest growing
       &nbsp;<a href="https://www.bioversalremedies.com/pcd-pharma-franchise-company/">
        Best PCD Pharma Franchise company in India
      </a>
      dedicated to provide high quality healthcare by providing
      &nbsp;<a href="https://www.bioversalremedies.com/third-party-pharma-manufacturing/">
        Third-Party Manufacturing
      </a>, Pharma Products, Pharmaceutical Franchisees and
      Medical Franchisees. Being a well known monopoly pharma company we are
      serving the country and even some neighboring countries. Bioversal Remedies
      works fast and includes a proper
      &nbsp;<a href="https://www.bioversalremedies.com/pcd-pharma-franchise/">
        PCD Pharma Franchise
      </a>
      &nbsp;program to offer PCD franchises to those interested.
    </p>

    <p className="serv_all__para">
      As a pharma franchise company, we allow our partners to use and
      manufacture our products. Each franchise business has different models to
      be followed. Therefore, we guarantee the right care and safety precautions
      while delivering our products. Our unique approach to PCD Pharma marketing
      has contributed to long-term growth. We have a wide range of products like
      Creams, Liquids, Injections and Antibiotics.
    </p>

    <p className="serv_all__para">
      Various firms market pharma products to show their strength. However, if
      you're offering high-quality products, there’s no need for heavy
      promotion—your quality speaks for itself. Bioversal Remedies follows
      ethical advertising and transparent practices.
    </p>

    {/* Section Heading */}
    <h2 className="heading-1" id="About_Bioversal_Remedies">
      About Bioversal Remedies – Leading PCD Pharma Franchise Company
    </h2>

    <p className="serv_all__para">
      Our products are certified for medical use and manufactured with strict
      quality standards. Bioversal Remedies is becoming more popular every day
      with its unique promotional strategy. We adopt the best practices to
      deliver top-quality products.
    </p>

    {/* Why Choose Section */}
    <h2 className="heading-1" id="Why_Choose_Bioversal_Remedies">
      Why Choose Bioversal Remedies for PCD Pharma Franchise
    </h2>

    <p className="serv_all__para">
      We offer an exceptional range of pharmaceuticals including Anti-Allergy,
      PPIs, Antibiotics, Injectables, Gynae, Ortho, Pediatric Medicine, Derma,
      and more. With 200+ products and many associates, we aim to provide
      high-end, reliable, and affordable medicines.
    </p>

    <p className="serv_all__para">
      Pharma franchise refers to a business privilege where a partner uses the
      company trademark to sell products. There are multiple franchise models
      depending on requirements.
    </p>

    {/* How to Become Partner */}
    <h2 className="heading-1" id="How_to_Become_Our_Franchise_Partner">
      How to Become Our Franchise Partner
    </h2>

    <p className="serv_all__para">
      Bioversal Remedies guides partners in choosing the right products to avoid
      financial risks. We ensure the best promotional support including visual
      aids, product images, and marketing materials.
    </p>

    <p className="serv_all__para">
      View our <strong>
        <a href="/assets/images/Bioversal-Glossary.pdf">
          Product List
        </a>
      </strong>.
    </p>

    {/* Contact Section */}
    <h3 className="heading-1">Contact Bioversal Remedies</h3>

    {/* WhatsApp Button */}
  <a
    href="https://api.whatsapp.com/send?phone=919053777905"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-btn"
    style={{
      display: "flex",
      alignItems: "center",
      backgroundColor: "#2DB742",
      padding: "12px 20px",
      borderRadius: "10px",
      width: "300px",
      textDecoration: "none",
      color: "#fff",
    }}
  >
    <img
      src="https://www.bioversalremedies.com/wp-content/plugins/wp-whatsapp/assets/img/whatsapp_logo.svg"
      alt="WhatsApp"
      style={{ width: "32px", marginRight: "10px" }}
    />
    <span style={{ fontSize: "18px", fontWeight: "bold" }}>Query Now!</span>
  </a>

          </div>
        </div>
        {/* Footer ==== */}

        {/* Footer END ==== */}
        <button
          className="back-to-top fa fa-chevron-up"
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default PcdPharmaFranchiseCompany;
